module.exports = __webpack_public_path__ + "img/logo.1c774f70.png";